import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { TermsAndConditionsResponse } from '../models';

export enum TermsAndConditionsActionTypes {
  GetTermsAndConditions = '[TermsAndConditions] GetTermsAndConditions',
  GetTermsAndConditionsSuccess = '[TermsAndConditions] GetTermsAndConditionsSuccess',
  GetTermsAndConditionsError = '[TermsAndConditions] GetTermsAndConditionsError',
  GetFAQ = '[TermsAndConditions] GetFAQ',
  GetFAQSuccess = '[TermsAndConditions] GetFAQSuccess',
  GetFAQError = '[TermsAndConditions] GetFAQError',
  GetPrivacyPolicy = '[TermsAndConditions] GetPrivacyPolicy',
  GetPrivacyPolicySuccess = '[TermsAndConditions] GetPrivacyPolicySuccess',
  GetPrivacyPolicyError = '[TermsAndConditions] GetPrivacyPolicyError',
}

export const getTermsAndConditionsAction = createAction(TermsAndConditionsActionTypes.GetTermsAndConditions);
export const getTermsAndConditionsSuccessAction = createAction(
  TermsAndConditionsActionTypes.GetTermsAndConditionsSuccess,
  props<{ termsAndConditions: Array<TermsAndConditionsResponse> }>()
);
export const getTermsAndConditionsErrorAction = createAction(
  TermsAndConditionsActionTypes.GetTermsAndConditionsError,
  props<{ failures: AppStateFailure }>()
);
export const getFAQAction = createAction(TermsAndConditionsActionTypes.GetFAQ);
export const getFAQSuccessAction = createAction(
  TermsAndConditionsActionTypes.GetFAQSuccess,
  props<{ faq: Array<TermsAndConditionsResponse> }>()
);
export const getFAQErrorAction = createAction(TermsAndConditionsActionTypes.GetFAQError, props<{ failures: AppStateFailure }>());
export const getPrivacyPolicyAction = createAction(TermsAndConditionsActionTypes.GetPrivacyPolicy);
export const getPrivacyPolicySuccessAction = createAction(
  TermsAndConditionsActionTypes.GetPrivacyPolicySuccess,
  props<{ privacyPolicy: Array<TermsAndConditionsResponse> }>()
);
export const getPrivacyPolicyErrorAction = createAction(
  TermsAndConditionsActionTypes.GetPrivacyPolicyError,
  props<{ failures: AppStateFailure }>()
);
